export { default } from './PswdMustChangeDialog'
export type { PswdMustChangeDialogProps } from './PswdMustChangeDialog'
